import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import styles from './card.style';
import { useColors } from '../../../hooks';

interface CardProps {
  containerStyle?: StyleProp<ViewStyle>;
  children: any;
  solid?: boolean;
  disabled?: boolean;
}

export function Card({
  children,
  containerStyle,
  solid,
  disabled = false,
}: CardProps) {
  const theme = useColors();
  return (
    <View
      pointerEvents={disabled ? 'none' : 'auto'}
      style={[
        styles.container,
        solid && styles.solid,
        { backgroundColor: theme.background, borderColor: theme.borderColor },
        containerStyle,
      ]}
    >
      {children}
    </View>
  );
}
